<footer>
  <div class="footer-content">
    <span class="copyright">&copy; Berner Fachhochschule, Digital Sustainability Lab</span>
    <a routerLink="/impressum" class="impressum">Impressum</a>
  </div>
</footer>